<template>
  <cell-box style="padding: 0.3rem 0;" :column="2">
    <cell-item label="姓名：" :value="info.patientName" />
    <cell-item label="性别：" :value="info.patientSex" />
    <cell-item label="床位：" :value="info.bedNo" />
    <cell-item label="住院号：" :value="info.inPatientNo" />
    <cell-item label="科室：" :value="info.departmentName" />
    <cell-item label="住院日期：" :value="info.inDate" />
    <cell-item label="费用总额：" :value="info.totalAmount" />
    <cell-item label="预交金额：" :value="info.preTotalAmount" />
  </cell-box>
</template>

<script>
import { CellBox, CellItem } from "@/components/cell";

export default {
  components: {
    CellBox,
    CellItem
  },
  props: {
    info: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>

<style></style>
